import React from 'react';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useFormikContext } from 'formik';
import { WidgetForm } from '../WidgetForm';
import { CreatWidgetFormValues, StepsEnum, WidgetTypes } from '../dashboard-widget-model';

interface Props {
  onClose: () => void;
}

export function SettingsWidgetFormDialog({ onClose }: Props) {
  const { values, setFieldValue } = useFormikContext<CreatWidgetFormValues>();

  const onBack = () => {
    if (values.byType === WidgetTypes.NUMBER) {
      setFieldValue('selectStep', StepsEnum.SELECT_NUMBER_TYPE);
    }

    if (values.byType === WidgetTypes.NUMBER_CHART) {
      setFieldValue('selectStep', StepsEnum.SELECT_CHART_TYPE);
    }

    if (values.byType === WidgetTypes.CHART) {
      setFieldValue('selectStep', StepsEnum.SELECT_CHART_TYPE);
    }

    if (values.byType === WidgetTypes.TABLE || values.byType === WidgetTypes.REQUIRING_ACTION) {
      setFieldValue('selectStep', StepsEnum.SELECT_WIDGET);
    }
  };

  return (
    <>
      <DialogTitle>
        <Grid container alignItems={'center'} justify={'space-between'}>
          <Grid item xs style={{ paddingTop: '10px' }}>
            <Typography variant='h6' style={{ fontWeight: 700, fontSize: '24px' }}>
              {values.isNew ? 'Add' : 'Edit'} Widget
            </Typography>
            <Typography variant='subtitle1' color='textSecondary'>
              Select and define your widget configuration
            </Typography>
          </Grid>
          <Grid item>
            <Box display='flex' alignItems='center'>
              <IconButton key='close' aria-label='Close' color='inherit' onClick={onClose}>
                <Close color='action' />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent id='dialog-content'>
        <WidgetForm />
      </DialogContent>
      <DialogActions style={{ marginBottom: '2rem', marginRight: '12px' }}>
        {values.isNew ? (
          <Button
            onClick={onBack}
            style={{
              textTransform: 'none',
            }}
          >
            Back
          </Button>
        ) : (
          <Button
            onClick={onClose}
            style={{
              textTransform: 'none',
            }}
          >
            Cancel
          </Button>
        )}
        <Button
          type='submit'
          color='primary'
          style={{
            textTransform: 'none',
          }}
          variant='contained'
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
}
